// Shared icon components used throughout the app.
// Uses Font Awesome for standard icons; keeps custom SVG only for brand/unique icons.

import {SVGProps} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faBell,
    faCamera,
    faLayerGroup,
    faWandMagicSparkles,
    faGear,
    faCircleInfo,
    faChevronRight,
    faChevronLeft,
    faChevronDown,
    faChevronUp,
    faStar,
    faPaperPlane,
    faDownload,
    faPlus,

    faEye,
    faEyeSlash,
    faBookOpen,
    faChartBar,
    faCreditCard,
    faBullhorn,
    faRotateLeft,
    faRotateRight,
    faCopy,
    faCheck,
    faXmark,
    faArrowRight,
    faEnvelope,
    faTriangleExclamation,
    faShieldHalved,
    faUpload,
    faStore,
    faPaintbrush,
    faBars,
    faSpinner,
    faCircleCheck,
    faBookmark,
    faImage,
    faAlignLeft,
    faAlignCenter,
    faAlignRight,
    faAlignJustify,
    faMinus,
    faHouse,
    faFlag,
    faLaptop,
} from '@fortawesome/free-solid-svg-icons';
import {
    faStar as faStarOutline,
    faTrashCan,
    faClone as faCloneRegular,
    faShareFromSquare,
} from '@fortawesome/free-regular-svg-icons';
import {
    faYoutube,
    faInstagram,
    faLinkedin,
    faFacebook,
    faGooglePlay,
    faApple,
} from '@fortawesome/free-brands-svg-icons';

type IconProps = SVGProps<SVGSVGElement> & { className?: string };

export function AppleIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faApple} className={className}/>;
}

export function PlayStoreIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faGooglePlay} className={className}/>;
}

export function BellIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faBell} className={className}/>;
}

export function CameraIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faCamera} className={className}/>;
}

export function LayersIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faLayerGroup} className={className}/>;
}

export function SparklesIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faWandMagicSparkles} className={className}/>;
}

export function SettingsIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faGear} className={className}/>;
}

export function InfoIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faCircleInfo} className={className}/>;
}

export function ChevronRightIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faChevronRight} className={className}/>;
}

export function ChevronLeftIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faChevronLeft} className={className}/>;
}

export function ChevronDownIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faChevronDown} className={className}/>;
}

export function ChevronUpIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faChevronUp} className={className}/>;
}

export function StarIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faStar} className={className}/>;
}

export function SendIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faPaperPlane} className={className}/>;
}

export function DownloadIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faDownload} className={className}/>;
}

export function PlusIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faPlus} className={className}/>;
}

export function TrashIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faTrashCan} className={className}/>;
}

export function EyeIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faEye} className={className}/>;
}

export function EyeOffIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faEyeSlash} className={className}/>;
}

export function BookOpenIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faBookOpen} className={className}/>;
}

export function BarChartIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faChartBar} className={className}/>;
}

export function CreditCardIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faCreditCard} className={className}/>;
}

export function MegaphoneIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faBullhorn} className={className}/>;
}

export function UndoIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faRotateLeft} className={className}/>;
}

export function RedoIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faRotateRight} className={className}/>;
}

export function CopyIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faCopy} className={className}/>;
}

export function CheckIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faCheck} className={className}/>;
}

export function XIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faXmark} className={className}/>;
}

export function ArrowRightIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faArrowRight} className={className}/>;
}

export function EmailIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faEnvelope} className={className}/>;
}

export function WarningIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faTriangleExclamation}
                            className={className}/>;
}

export function ShieldCheckIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faShieldHalved} className={className}/>;
}

export function UploadIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faUpload} className={className}/>;
}

export function StoreIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faStore} className={className}/>;
}

export function PaintbrushIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faPaintbrush} className={className}/>;
}

export function HamburgerIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faBars} className={className}/>;
}

export function SpinnerIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faSpinner} className={className}/>;
}

export function CheckCircleIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faCircleCheck} className={className}/>;
}

export function BookmarkIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faBookmark} className={className}/>;
}

export function ImageIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faImage} className={className}/>;
}

export function AlignLeftIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faAlignLeft} className={className}/>;
}

export function AlignCenterIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faAlignCenter} className={className}/>;
}

export function AlignRightIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faAlignRight} className={className}/>;
}

export function AlignJustifyIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faAlignJustify} className={className}/>;
}

export function MinusIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faMinus} className={className}/>;
}

export function FileExportIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faShareFromSquare} className={className}/>;
}

export function DuplicateIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faCloneRegular} className={className}/>;
}

export function StarOutlineIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faStarOutline} className={className}/>;
}

export function YoutubeIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faYoutube} className={className}/>;
}

export function InstagramIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faInstagram} className={className}/>;
}

export function LinkedinIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faLinkedin} className={className}/>;
}

export function FacebookIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faFacebook} className={className}/>;
}

export function HomeIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faHouse} className={className}/>;
}

export function FeedbackIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faFlag} className={className}/>;
}

export function LaptopIcon({className}: IconProps) {
    return <FontAwesomeIcon icon={faLaptop} className={className}/>;
}
